import React from "react";

export const Footer = () => {
    return (
        <div>
            <footer>
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <p>Copyright © 2022 <span><b>Frishtey Media</b></span>  All Rights Reserved.
                                <br />
                                Designed by&nbsp;
                                <a href="/" target="_parent" title="Frishtey Media" style={{ fontWeight: '500' }}>
                                    Frishtey Media
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    )
}